import type { Logger } from "@expert/logging";

import { DraggableComponent } from "@expert/solve-tools";

import { useGuidedBrowsingStore } from "../store/useGuidedBrowsingStore";
import styles from "./GuidedBrowsingModal.module.css";

interface GuidedBrowsingModalProps {
    sessionId: string;
    logger: Logger;
}

export function GuidedBrowsingModal({ sessionId, logger }: GuidedBrowsingModalProps) {
    const session = useGuidedBrowsingStore((state) => state.getSession(sessionId));
    const frameLocation = useGuidedBrowsingStore((state) => state.frameLocation);
    const frameSize = useGuidedBrowsingStore((state) => state.frameSize);
    // Actions are stable refs; read once without subscribing.
    const { closeModal, setFrameLocation, setFrameSize } = useGuidedBrowsingStore.getState();

    if (!session || session.deliveryStatus === "failed") {
        return null;
    }

    return (
        <DraggableComponent
            backgroundColor="var(--mantine-color-dark-5)"
            iconColor="var(--mantine-color-dark-0)"
            location={frameLocation}
            logger={logger}
            onClose={() => closeModal(sessionId)}
            opened={session.isModalOpen}
            setLocation={setFrameLocation}
            setSize={setFrameSize}
            size={frameSize}
            testId="guided-browsing"
            title="Guided Browsing"
        >
            <iframe
                className={styles.iframe}
                height="100%"
                width="100%"
                src={session.url}
                sandbox="allow-scripts allow-forms allow-same-origin"
                title="guided-browsing-iframe"
                onContextMenu={(event) => event.preventDefault()}
            />
        </DraggableComponent>
    );
}
